import { apolloClient } from '@/lib/apollo';

export async function safeResetApolloStore() {
  try {
    // Stop active observers to avoid auth teardown refetch races.
    apolloClient.stop();
    await apolloClient.clearStore();
  } catch (error) {
    console.error('[ApolloStoreReset] logout reset failed', error);
    throw error;
  }
}
